import * as definitions from '../resources/definitions';

export default Object.keys(definitions.serverless.ResourceTypes)
  .filter(type => 'Metrics' in definitions.serverless.ResourceTypes[type])
  .map(type => ({
    ...definitions.serverless.ResourceTypes[type].Metrics,
    nodeType: type
  }));
